import React, { useContext, useState } from 'react'
import { Api } from '../contexts/Api';
import { Link, useNavigate } from 'react-router-dom';
import slugify from 'slugify';
import { Pagination, Modal, Box, Button, Typography } from '@mui/material';
import { AuthContext } from '../contexts/AuthContext';
import EditCoef from './EditCoef';

function ProductsList() {
    const navigate = useNavigate();
    const { profile } = useContext(AuthContext);
    const { products, handleFilterChange, pageCount } = useContext(Api);
    const [open, setOpen] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);

    const handleDeleteClick = (sku) => {
        setProductToDelete(sku);
        setOpen(true);  // Show the modal
    };

    const handleClose = () => {
        setOpen(false); // Close the modal
    };

    const handleConfirmDelete = async () => {
        if (productToDelete) {
            try {
                const response = await fetch('https://api.elnaf.fi/api/removeProduct.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ 'SKU': productToDelete, 'username': profile.username }),
                });
                const result = await response.json();
                console.log(result);
                if (result.status === 'success') {
                    alert('Product removed successfully!');
                    navigate('/products');
                } else {
                    alert('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Error removing product:', error);
            }
        }
        setOpen(false); // Close the modal after confirming
    };
    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card custom-card">
                    <div className="card-header justify-content-between">
                        <div className="card-title">
                            Products List
                        </div>
                        <div className="d-flex gap-3">
                            <input onChange={(e) => handleFilterChange('q', e.target.value)} className="form-control form-control-sm" type="text" placeholder="Search Here" aria-label=".form-control-sm example" />
                            <Link to="/add-product" className="btn btn-primary btn-sm me-2 text-nowrap"><i className="ri-add-line me-1 fw-medium align-middle" />Add Product</Link>
                        </div>
                    </div>
                    <div className="card-body">
                        <EditCoef />
                        <div className="table-responsive">
                            <table className="table text-nowrap border">
                                <thead>
                                    <tr>

                                        <th scope="col">SKU</th>
                                        <th scope="col">Marka</th>
                                        <th scope="col">Category</th>
                                        <th scope="col">Seller</th>
                                        <th scope="col">Price</th>
                                        <th scope="col">Stock</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {products && products.map((prod, index) => (

                                        <tr className="product-list">
                                            <td>
                                                <div className="d-flex">
                                                    <span className="avatar avatar-md avatar-square bg-primary-transparent p-1"><img src={prod.Foto} className="w-100 h-100" alt="..." /></span>
                                                    <div className="ms-2">
                                                        <p className="fw-semibold mb-0 d-flex align-items-center"><Link to={`https://elnaf.fi/product/${slugify(prod.name + '-sku-' + prod.SKU)}`}>{prod.SKU}</Link></p>
                                                        <p className="fs-12 text-muted mb-0">{prod.Parent}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span>{prod.MARKA}</span>
                                            </td>
                                            <td>
                                                <span>
                                                    {prod.Category}
                                                </span>
                                            </td>
                                            <td>{prod.seller}</td>
                                            <td>{'€' + prod.Price}</td>
                                            <td>{prod.stock}</td>
                                            <td>
                                                <div className="hstack gap-2 fs-15">
                                                    <Link to={`/edit-product/${prod.SKU}`} className="btn btn-icon btn-sm btn-primary-light"><i className="ri-edit-line" /></Link>
                                                    <button onClick={() => handleDeleteClick(prod.SKU)} className="btn btn-icon btn-sm btn-danger-light product-btn"><i className="ri-delete-bin-line" /></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex align-items-center flex-wrap overflow-auto">

                            <div className="ms-auto">
                                <Pagination onChange={(event, value) => handleFilterChange('page', value)} count={pageCount} variant="outlined" shape="rounded" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Are you sure you want to delete this product?
                    </Typography>
                    <div className="mt-3">
                        <Button onClick={handleClose} color="secondary" sx={{ mr: 2 }}>
                            Cancel
                        </Button>
                        <Button onClick={handleConfirmDelete} color="primary">
                            OK
                        </Button>
                    </div>
                </Box>
            </Modal>
        </div>

    )
}

export default ProductsList